<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Tiket No. {{ data.core.no }}</h5>
                <div class="text-right">
                    <h5 class="mb-0"><b-badge :variant="parseBadgeVariantTipe(data.core.status.id)">{{ data.core.status.name.toUpperCase() }}</b-badge></h5>
                </div>
            </div>
            <hr />
            <div class="mb-3">
                <b-button variant="primary" class="mr-2" @click="$bvModal.show('modal-history')">
                    <i class="fa fa-history mr-2" />Histori Status
                </b-button>
                <b-button v-if="roleId != 4" variant="primary" class="mr-2" @click="preparePrint">
                    <i class="fa fa-print mr-2" />Cetak Tiket
                </b-button>
                <b-button v-if="data.core.status.id == 1 && roleId == 3" variant="success" class="mr-2" @click="$bvModal.show('modal-take')">
                    <i class="fa fa-pencil mr-2" />Ambil Tiket
                </b-button>
                <b-button v-if="data.core.status.id == 2 && roleId == 3" variant="success" class="mr-2" @click="$bvModal.show('modal-done')">
                    <i class="fa fa-check mr-2" />Set Selesai
                </b-button>
                <b-button v-if="data.core.status.id == 3 && roleId == 2" variant="success" class="mr-2" @click="$bvModal.show('modal-close')">
                    <i class="fa fa-check-circle mr-2" />Tutup Tiket
                </b-button>
                <b-button v-if="data.core.status.id == 1 && roleId == 2" variant="danger" class="mr-2" @click="$bvModal.show('modal-delete')">
                    <i class="fa fa-times mr-2" />Hapus Tiket
                </b-button>
            </div>
            <div class="stronger">Engine</div>
            <div class="mb-3">{{ data.core.engine }} - {{ data.core.tipe }}</div>
            <div class="stronger">Lokasi</div>
            <div class="mb-3">{{ data.core.lokasi }} - {{ data.core.wilayah }}</div>
            <div class="stronger">Dibuat / dilaporkan oleh</div>
            <div class="mb-3">{{ data.dibuatOleh }}</div>
            <div class="stronger">Dikerjakan oleh</div>
            <div>{{ data.dikerjakanOleh || "-" }}</div>
            <hr />
            <div class="stronger">Keluhan</div>
            <span style="white-space: pre-line" v-html="data.keluhan" />
            <hr />
            <div class="stronger">Tindakan</div>
            <span style="white-space: pre-line" v-html="data.tindakan" />
            <hr />
            <div class="stronger">Saran</div>
            <span style="white-space: pre-line" v-html="data.saran" />
        </b-card>
        <b-modal id="modal-history" title="Histori Status" centered hide-footer>
            <div class="font-weight-bold">OPEN</div>
            <div class="mb-3">{{ data.core.createdBy }}, {{ $helper.parseDate(data.core.createdAt) }} - {{ $helper.parseHourMinute(data.core.createdAt) }}</div>
            <div class="font-weight-bold">ONGOING</div>
            <div v-if="data.takenBy != null" class="mb-3">{{ data.takenBy }}, {{ $helper.parseDate(data.takenAt) }} - {{ $helper.parseHourMinute(data.takenAt) }}</div>
            <div v-else class="mb-3">-</div>
            <div class="font-weight-bold">DONE</div>
            <div v-if="data.doneBy != null" class="mb-3">{{ data.doneBy }}, {{ $helper.parseDate(data.doneAt) }} - {{ $helper.parseHourMinute(data.doneAt) }}</div>
            <div v-else class="mb-3">-</div>
            <div class="font-weight-bold">CLOSED</div>
            <div v-if="data.core.closedBy != null" class="mb-3">{{ data.core.closedBy }}, {{ $helper.parseDate(data.core.closedAt) }} - {{ $helper.parseHourMinute(data.core.closedAt) }}</div>
            <div v-else class="mb-3">-</div>
        </b-modal>
        <b-modal id="modal-delete" title="Pembatalan Tiket" centered no-close-on-esc no-close-on-backdrop>
            Batalkan tiket? Masukan alasan pembatalan tiket:
            <b-form-input v-model="input.alasan" maxlength="255" placeholder="Alasan" />
            <b-alert class="mt-3 mb-0" variant="danger" show>
                <strong>Perhatian!</strong> Tiket yang sudah dibatalkan tidak dapat dikembalikan!
            </b-alert>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()" :disabled="isSubmitting">
                    Batal
                </b-button>
                <b-button variant="primary" @click="deleteTicket" :disabled="isSubmitting">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-take" title="Konfirmasi" centered no-close-on-esc no-close-on-backdrop>
            Ambil tiket ini? Status tiket akan dirubah menjadi ONGOING (dalam pengerjaan)!
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()" :disabled="isSubmitting">
                    Batal
                </b-button>
                <b-button variant="primary" @click="takeTicket" :disabled="isSubmitting">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-done" size="lg" title="Set Selesai" centered no-close-on-esc no-close-on-backdrop hide-footer>
            Silahkan isi beberapa keterangan dibawah ini untuk menyatakan penyelesaiaan tiket pekerjaan!
            <b-form-group label="Dikerjakan oleh" class="mt-3" label-for="i2">
                <b-form-input v-model="input.dikerjakanOleh" maxlength="255" />
            </b-form-group>
            <b-form-group label="Tindakan" class="mb-0" label-for="i2">
                <b-form-textarea
                    v-model="input.tindakan"
                    placeholder="Tulis tindakan..."
                    rows="5"
                    max-rows="5"
                    maxlength="500"
                />
            </b-form-group>
            <div class="text-right small text-muted mb-3">{{ input.tindakan.length }} / 500</div>
            <b-form-group label="Saran" class="mb-0" label-for="i2">
                <b-form-textarea
                    v-model="input.saran"
                    placeholder="Tulis saran..."
                    rows="5"
                    max-rows="5"
                    maxlength="500"
                />
            </b-form-group>
            <div class="text-right small text-muted mb-3">{{ input.saran.length }} / 500</div>
            <div class="mt-2 text-right">
                <b-btn variant="primary" @click="openSetSelesaiConfirmModal">Simpan</b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-confirm-done" title="Konfirmasi" centered no-close-on-esc no-close-on-backdrop>
            Konfirmasi untuk set selesai tiket ini dengan keterangan yang anda input?
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()" :disabled="isSubmitting">
                    Batal
                </b-button>
                <b-button variant="primary" @click="finishTicket" :disabled="isSubmitting">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-close" title="Konfirmasi" centered no-close-on-esc no-close-on-backdrop>
            Nyatakan bahwa pengerjaan tiket ini sudah selesai sepenuhnya dan tutup tiket?
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()" :disabled="isSubmitting">
                    Batal
                </b-button>
                <b-button variant="primary" @click="closeTicket" :disabled="isSubmitting">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-print" title="Cetak Tiket" centered no-close-on-esc no-close-on-backdrop hide-footer>
            <div v-if="isPrinting" class="text-center">
                <b-spinner class="loading-spinner" variant="dark"></b-spinner>
                <div class="mt-2">Mohon menunggu...</div>
            </div>
            <div v-else>
                <div class="mb-2">Tiket siap dicetak, silahkan klik tombol dibawah ini:</div>
                <a :href="path" target="_blank">
                    <b-button variant="primary">
                        <i class="fa fa-print mr-2" />Cetak Tiket
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'tiket-detail',
    data() {
        return {

            roleId: 1,

            initStatus: 0,
            isSubmitting: false,

            isPrinting: false,
            path: "",

            data: {
                core: {
                    id: 0,
                    no: "",
                    engine: "",
                    tipe: "",
                    lokasi: "",
                    wilayah: "",
                    status: { id: 0, name: "" },
                    createdBy: "",
                    createdAt: "",
                    closedBy: "",
                    closedAt: ""
                },
                dibuatOleh: "",
                dikerjakanOleh: "",
                keluhan: "",
                tindakan: "",
                saran: "",
                takenBy: "",
                takenAt: "",
                doneBy: "",
                doneAt: ""
            },

            input: {
                alasan: "",
                tindakan: "",
                saran: "",
                dikerjakanOleh: ""
            }

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            this.$axios.get("tiket/" + this.$route.params.no).then(res => {

                console.log(res)
                this.data = res.data
                this.initStatus = 1

            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        takeTicket() {

            let payload = new FormData()
            payload.append("tiketId", this.data.core.id)

            this.isSubmitting = true
            this.$axios.post("tiket/take", payload).then(res => {

                this.$bvModal.hide("modal-take")
                this.$helper.toastSuccess(this, "Tiket berhasil diambil!")
                this.init()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        deleteTicket() {

            if(this.$helper.isBlank(this.input.alasan)) {
                return this.$helper.toastError(this, "Alasan tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("tiketId", this.data.core.id)
            payload.append("alasan", this.input.alasan)

            this.isSubmitting = true
            this.$axios.post("tiket/delete", payload).then(res => {

                this.$bvModal.hide("modal-delete")
                this.$helper.setFlash(`Tiket No. ${this.data.core.no} berhasil dihapus!`)
                this.$router.push("/tiket")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        finishTicket() {

            let payload = new FormData()
            payload.append("tiketId", this.data.core.id)
            payload.append("tindakan", this.input.tindakan)
            payload.append("saran", this.input.saran)
            payload.append("dikerjakanOleh", this.input.dikerjakanOleh)

            this.isSubmitting = true
            this.$axios.post("tiket/finish", payload).then(res => {

                this.$bvModal.hide("modal-confirm-done")
                this.$bvModal.hide("modal-done")
                this.$helper.toastSuccess(this, `Tiket berhasil diselesaikan!`)
                this.init()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        closeTicket() {

            let payload = new FormData()
            payload.append("tiketId", this.data.core.id)

            this.isSubmitting = true
            this.$axios.post("tiket/close", payload).then(res => {

                this.$bvModal.hide("modal-close")
                this.$helper.setFlash(`Tiket No. ${this.data.core.no} berhasil ditutup!`)
                this.$router.push("/tiket")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        openSetSelesaiConfirmModal() {

            if(this.$helper.isBlank(this.input.dikerjakanOleh)) {
                return this.$helper.toastError(this, "Dikerjakan oleh tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.tindakan)) {
                return this.$helper.toastError(this, "Tindakan tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.saran)) {
                return this.$helper.toastError(this, "Saran tidak boleh kosong!")
            }

            this.$bvModal.show('modal-confirm-done')

        },

        preparePrint() {

            this.$bvModal.show("modal-print")
            this.isPrinting = true

            this.$axios.get("tiket/print-tiket/" + this.data.core.id).then(res => {
                this.path = this.$BASE_FILE_PATH + res.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-print")
            })
            .finally(() => {
                this.isPrinting = false
            })

        },

        parseBadgeVariantTipe(id) {
            switch(id) {
                case 0: return "danger"
                case 1: return "warning"
                case 2: return "dark"
                case 3: return "primary"
                case 4: return "success"
                default: return "light"
            }
        }

    },
    created() {
        this.roleId = Number(localStorage.getItem("roleId"))
        this.init()
    }
}
</script>

<style scoped>
    .stronger {
        font-weight: 600;
    }
</style>
